<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-loan__tloanapply}">
      <!-- 请输入支付密码 -->
      <el-card class="box-card1" v-show="isSHowPasswordControl">
        <p>中运交投</p>
        <p class="p2">请输入支付密码</p>

        <!-- HTML的标签用到的属性尽量不要动，如有需要调整样式，可自行增加class即可 -->
        <!-- 整个div会默认撑满父容器宽高，继承父容器颜色字体大小，点击元素会弹出密码键盘 -->
        <div class="passWord-box">
          <div id="ipt_pwd2" class="ipt_pwd">
            <span id="LOGPASS2_SHOW">请输入密码</span>
            <input
              id="LOGPASS2"
              class="default input_search"
              type="password"
              disabled="disabled"
            />
            <div id="keyboardBtn2" class="ipt_pwd_rjp default"></div>
          </div>
          <!-- <div id="ipt_pwd3" class="ipt_pwd">
                <span id="LOGPASS3_SHOW">请确认密码</span>
                <input id="LOGPASS3" class="default input_search" type="text" disabled="disabled" />
                <div id="keyboardBtn3" class="ipt_pwd_rjp default"></div>
              </div> -->
        </div>
        <div class="get-password-box">
          <el-button @click="getPassword('off')">取消支付</el-button>
          <el-button
            :disabled="zf"
            id="get-password"
            @click="getPassword('pay')"
            >确认支付</el-button
          >
        </div>
      </el-card>
    </div>
    <el-card class="box-yzm" v-if="isyzm">
      <p>中运交投</p>
      <p class="p2">请输入验证码({{ $store.state.info.mobile }})</p>
      <div>
        <div class="input-box">
          <div
            class="code-item"
            :class="
              codeValue.length == 0 && inputFocus ? 'code-item-active' : ''
            "
          >
            {{ codeValue[0] }}
          </div>
          <div
            class="code-item"
            :class="
              codeValue.length == 1 && inputFocus ? 'code-item-active' : ''
            "
          >
            {{ codeValue[1] }}
          </div>
          <div
            class="code-item"
            :class="
              codeValue.length == 2 && inputFocus ? 'code-item-active' : ''
            "
          >
            {{ codeValue[2] }}
          </div>
          <div
            class="code-item"
            :class="
              codeValue.length == 3 && inputFocus ? 'code-item-active' : ''
            "
          >
            {{ codeValue[3] }}
          </div>
          <div
            class="code-item"
            :class="
              codeValue.length == 4 && inputFocus ? 'code-item-active' : ''
            "
          >
            {{ codeValue[4] }}
          </div>
          <div
            class="code-item"
            :class="
              codeValue.length >= 5 && inputFocus ? 'code-item-active' : ''
            "
          >
            {{ codeValue[5] }}
          </div>
          <input
            class="input-code"
            v-model="codeValue"
            :maxlength="6"
            type="tel"
            @blur="codeInputBlur"
            @focus="codeInputFocus"
            @input="codeInputChange"
          />
        </div>
      </div>
      <div class="footer-btn">
        <el-button
          @click="
            () => {
              (isyzm = false), (codeValue = ''), getDataList();
            }
          "
          >取消</el-button
        >
        <el-button @click="yzm()">确认</el-button>
      </div>
    </el-card>
  </el-card>
</template>
  
  <script>
import AddOrUpdate from "./tloanapply-add-or-update";
import AddOrUpdateloan from "./tloanapply-add-or-updateloan";
import AddOrUpdatee from "./tloanapply-add-or-updatee";
import perfect from "./tloanapply-add-or-perfect.vue";
import { getCancelInfo } from "../../../api/api";

export default {
  created() {
    this.$http
      .post(
        "/sys/lianlianpasswordparsing/checkSign?checkSign=" +
          this.$route.query?.item2
      )
      .then((r) => {
        if (r.data.code == 0) {
          
          if (r.data.data) {
            if(this.isAfterCurrentTime(r.data.data.createDate)){
              this.getFactor(() => {
              this.isSHowPasswordControl = true;
            });
            }else{
              this.$message.error('操作繁忙')
            }
           
           
          } else {
           
            this.getFactor(() => {
              this.isSHowPasswordControl = true;
            });
          }
          return
        }
        this.message.error(r.data.msg)
      });
  },

  data() {
    return {
      zf: false,
      lastDay: "",
      yzmData: {},
      copyUrlStatus: false, //获取链接弹窗
      copyUrl: "", //要复制的url
      copytitle: "",
      isperfect: false,
      isNotificationMethod: true, // 默认线上
      isSigningMethod: true, // 默认线上
      isyzm: false,
      codeValue: "",
      applyId: "",
      isSHowPasswordControl: false,
      passwordInstance: "",
      perfectObj: {},
      isdisabled: false,
      perfectInfoObj: {},
      options: {
        // "map_arr": "Wyc0MycsICc1NycsICc3MScsICcxMjEnLCAnMTI2JywgJzEyNCcsICc5MCcsICcxMTInLCAnODknLCAnOTMnLCAnMTA1JywgJzgxJywgJzExMycsICcxMjUnLCAnNjgnLCAnMzgnLCAnODUnLCAnNjUnLCAnMTE4JywgJzgwJywgJzg3JywgJzkxJywgJzQ0JywgJzMzJywgJzc4JywgJzg4JywgJzk2JywgJzEwOScsICc2MScsICc2NicsICc0MCcsICc4MicsICc3MicsICcxMjAnLCAnOTUnLCAnMTEwJywgJzQ2JywgJzg2JywgJzEwNycsICc1MCcsICc3MCcsICc5OCcsICcxMTcnLCAnMzYnLCAnMTAxJywgJzgzJywgJzQ4JywgJzExNCcsICc2NycsICc3NycsICcxMDgnLCAnMTAwJywgJzM1JywgJzczJywgJzY5JywgJzk5JywgJzEwMicsICc3NicsICc3NScsICcxMDQnLCAnNDknLCAnOTInLCAnNjInLCAnNTgnLCAnNTMnLCAnNzknLCAnOTcnLCAnNDUnLCAnNDEnLCAnMTE5JywgJzEyMycsICc1MScsICc2MycsICc0NycsICcxMDYnLCAnMzknLCAnMTExJywgJzExNScsICczNCcsICc5NCcsICcxMjInLCAnNjQnLCAnNTknLCAnMTE2JywgJzM3JywgJzc0JywgJzU1JywgJzYwJywgJzU0JywgJzUyJywgJzQyJywgJzg0JywgJzEwMycsICc1Nidd",
        // "license":"UjNpRHFyYWhSYzk5R1AzcTBCb1ZucURyLzhpekNiN1dGYkRWM1A3NjlnSzZnK0VZMDVzeno3akYrYS84VlR4UHhxRkFJRjJmeWdWKzJsU1hTV2hNMzg5WTBpbFk0bGhzU01GcXQvOTcyQmZ4akNtUXlrNEpMVnk0OXR0eXhRZ3RpYmFIMXkxcHg5UDZIbnBweG8rbGZqcS9Yekh1VGJ1K3kyZnBFS3didC9nPXsiaWQiOjAsInR5cGUiOiJ0ZXN0IiwicGxhdGZvcm0iOjEwLCJub3RiZWZvcmUiOiIyMDIyMDUzMCIsIm5vdGFmdGVyIjoiMjAyMjExMzAifQ==",
        // "oid_partner":"2020042904425468",
        // "random_key":"241a606e-a4ff-49f4-b102-882b61b36bdf",
        // "random_value":"63000403063155227830323742731688",
        // "ret_code":"0000",
        // "ret_msg":"交易成功",
        // "rsa_public_content":"308189028181009017e40c4b053ef663903066618131e705a91641441d8bc5de082a12147559dcbc790e7b85a0e42a388effa2b7d0c5f734733ef14869fb735b5245bda1d79e32c35004288190e080f8abe8ae7c8f2ff81738c1c32d6e944be7ad1197cb1d8c76455d6da8d623a0513647f5a59d1e9aa6ca077f136040b550ad411728455bf6230203010001",
        // "sm2_key_hex":"1093A047C5CBF48283EC7A210703F3FF9EA4448DC15D56B4CD82FCB27DAD2D45F2BB0BF953BCEBB635D9D34E473ECEFC9F25880EB1669F94DE050A29AC86F308",
        // "user_id":"2021060401291390051"
      },
      id: "",
      // actionUrl: `${window.SITE_CONFIG["apiURL"]}/sys/oss/upload?token=${Cookies.get("token")}`,
      actionUrl: `${window.SITE_CONFIG["apiURL"]}/sys/oss/upload`,
      dialogStr: "",
      previewPdfUrl: "",
      code: false,
      time: 0,
      codeValue: "",
      inputFocus: false,
      addOrUpdateCVisible: false,
      signed: false,
      cancel: false,
      addOrUpdateCloanVisible: false, //放款确认
      uploadDialogVisible: false,
      dialogVisible: false,

      userType: [],
      dataForm: {
        mobile: "",
        companyId: "",
        agreementCode: "",
        lendingStatus: "",
      },

      curRowObj: {
        id: "",
      },
      signObj: {},
      cancelObj: {},
    };
  },

  watch: {
    $route: {
      handler(newVal, odlVal) {
        console.log(newVal);
        //  debugger
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    aa() {
      // window.opener.close()
      window.location.href = "about:blank";
      //         var userAgent = navigator.userAgent;
      // if (userAgent.indexOf("Firefox") != -1 || userAgent.indexOf("Chrome") !=-1)	{
      // undefined

      //     window.location.href = "about:blank"
      //   }else {
      //     undefined
      //     window.opener = null;
      //     window.open("about:blank", "_self");
      //     window.close();
      //   }
    },
    isAfterCurrentTime(dateStr) {
      let dateTime = new Date(dateStr);
      let currentDateTime = new Date();
      let res =  currentDateTime.getTime() - dateTime.getTime()
    
      return res > 10000;
    },

    getFactor(fn = () => {}) {
      this.$http
        .get("/api/trans/getRandom")
        .then((r) => {
          if (r.data.code == "0") {
            // console.log(r.data.data);
            this.options = r.data.data;
            this.passwordInstance = this.initPassword(this.options);
         
            fn();
          } else {
            this.$message({
              type: "error",
              message: "获取随机因子失败",
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "error",
            message: "token错误",
          });
        });
    },

    // 验证码输入框input
    codeInputChange() {
      if (this.codeValue && this.codeValue.length >= 4) {
        // do soming...
      }
    },
    // 验证码输入框失去焦点
    codeInputBlur() {
      this.inputFocus = false;
    },
    // 验证码输入框获取到焦点
    codeInputFocus() {
      this.inputFocus = true;
    },

    createPassword() {
      this.getFactor(() => {
        this.isSHowPasswordControl = true;
      });
    },
    initPassword(options = {}) {
      // eslint-disable-next-line
      const passowrd = new showKeyBord({
        png: "//mpay-static.oss-cn-hangzhou.aliyuncs.com/html/lib/state-secret/img", // 图片路径，用这个就行了，也可以下载到本地
        click_objId: "#keyboardBtn2", // 触发显示键盘的Dom节点Id
        regExp1: "[\\S\\s]", // 输入过程限制的正则，不匹配正则的字符不让输入
        regExp2: "^[\\S\\s]{6,12}$", // 输入完成后的正则，与getValid()对应，判断输入值是否匹配该正则
        Input_texId: "#LOGPASS2", // 接收内容的Dom节点Id
        parent_objId: "#ipt_pwd2", // 将键盘插入到何处的Dom节点Id
        placeholderId: "#LOGPASS2_SHOW", // span标签的id，该span用于模拟Input_texId的placeholder
        len: "12", // 表示最大允许输入多少个字符[可以不传递]
        keyBordLeft: "",
        keyBordTop: "",
        chaosMode: 0, // 混乱模式,0:无混乱;1:打开时乱一次;2:每输入一个字符乱一次,默认值0
        clickStatus: 0, // 按键状态,0:鼠标划过、悬浮时按键无变化;1:鼠标划过、悬浮时按键的颜色变化,默认值0
        titlefont: "安全支付输入",
        backfont: "退 格",
        capsfont: "切换大/小写",
        surefont: "确定",
        isen: false,
        callBack: () => {}, // 密码校验成功回调
        errorCallBack: () => {}, // 密码校验失败回调
        rsaPublicKey: options.rsa_public_content, // RSA加密必须参数，国密加密可不要
        sm2KeyHex: options.sm2_key_hex, // 国密加密必须参数，RSA加密可不要
        license: options.license, // 必须参数
      });
      passowrd.initOptions();
      return passowrd;
    },

    getPassword(r) {
      this.zf = true;
      if (r == "off") {
        this.isSHowPasswordControl = false;
        this.passwordInstance.clearPWD();
        return;
      }

      this.passwordInstance.setRandKey(this.options.random_value); // 先设置随机key

      const password = this.passwordInstance.getOutputSM(); // 国密加密密码

      const rsaPassword = this.passwordInstance.getOutput(); // RSA加密密码
      // hash用于比对密码是否一致，同一个密码加密密文可能不同，hash一定相同
      const hash = this.passwordInstance.getHash(); // RSA加密密码

      this.$http
        .post("/sys/lianlianpasswordparsing/passwordParse", {
          checkSign: this.$route.query?.item2,
          password: password,
          randomKey: this.options.random_key,
        })
        .then((r) => {
      
          this.zf = false;
          if (r.data.code != 0) {
            this.$message.error(r.data.msg);
            return;
          }

          this.$message.success(r.data.msg);
          setTimeout(() => {
            // window.close()
            // window.location.href = "about:blank";
            window.location.replace("about:blank");
          }, 1000);
        })
        .catch((e) => {
          this.zf = false;
        });
      // if(process.env.NODE_ENV == 'development'){
      //   // window.open('http://test.testzytree.com.cn/slivertree/zijie/jxhs/gjjd/index.html?password=' + password)
      //   window.location.href = 'http://test.testzytree.com.cn/slivertree/zijie/jxhs/gjjd/index.html?item1=' + password +'&item2=' + this.options.random_key

      // }else{
      //   window.location.href = 'https://zheyin.slivertree.com/slivertree/zijie/jxhs/gjjd/index.html?item1=' + password +'&item2=' + this.options.random_key
      // }

      // this.$http
      //   .post("/api/trans/transfer", {
      //     applyId: this.applyId,
      //     password: password,
      //     postscript: "暂无说明",
      //     randomKey: this.options.random_key,
      //   })
      //   .then((r) => {
      //     let data = r.data.data;

      //     if (data.ret_code == "0000") {
      //       this.passwordInstance.clearPWD();
      //       this.isSHowPasswordControl = false;
      //       this.$message({
      //         type: "success",
      //         message: data.ret_msg,
      //       });
      //     } else if (data.ret_code == "8888") {
      //       this.yzmData = data;
      //       this.$message({
      //         type: "warning",
      //         message: "请输入验证码",
      //       });
      //       this.passwordInstance.clearPWD();
      //       this.isSHowPasswordControl = false;
      //       this.isyzm = true;
      //     } else {
      //       this.$message({
      //         type: "error",
      //         message: data.ret_msg,
      //       });
      //       this.passwordInstance.clearPWD();
      //       this.isSHowPasswordControl = false;
      //     }
      //     this.getDataList();
      //     this.getFactor();
      //   });
      // const hash2 = this.passwordInstance2.getHash() // RSA加密密码
      // console.log("确认密码HASH是", hash2)
    },
    yzm() {
      this.$http
        .post("/api/trans/validationSms", {
          applyId: this.signObj.id,
          token: this.yzmData.token,
          totalAmount: this.yzmData.total_amount,
          verifyCode: this.codeValue,
          txnSeqno: this.yzmData.txn_seqno,
          postscript: "交易明细",
        })
        .then((r) => {
          if (r.data.data.ret_code == "0000") {
            this.$message({
              type: "success",
              message: r.data.data.ret_msg,
            });
            this.codeValue = "";
            this.isyzm = false;
          } else {
            this.$message({
              type: "error",
              message: r.data.data.ret_msg,
            });
          }
          this.getDataList();
          this.getFactor();
        });
    },
  


    ifadult(row) {
      let flag = true;
      for (let arr = 0; arr < row.coBorrowerIdCard.length; arr++) {
        if (!this.analyzeIDCard(row.coBorrowerIdCard[arr]) && row.borrowerType == 'PERSONAGE') {
          flag = false;
          this.$message({
            type: "error",
            message: "暂不支持未成年签署",
          });
          return flag;
        }
      }
      return flag;
    },
    // 签约 解约
    async sign(row, n) {
      // console.log(row.coBorrowerIdCard.push(row.idNo))
      // console.log(row.coBorrowerIdCard)
      this.setTime();
      if (n == 2) {
        if (row !== "edit") {
          this.signObj = row;
        }

        if (this.signed) return;
        if (this.ifadult(row)) {
          this.$http.get("/loan/sign/" + row.id).then((r) => {
            if (r.data.code != 0) {
              this.$message({
                type: "error",
                message: r.data.msg,
              });
            } else {
              this.$message({
                type: "success",
                message: r.data.msg,
              });
            }
          });
          this.id = row.custId;
          this.signed = true;
        }
      } else {
        let res = await getCancelInfo(row.id);
        console.log(res.data);

        if (res.data.code == 0) {
          this.cancelObj = res.data.data;
          this.$http.get("/loan/untie/" + row.id).then((r) => {
            if (r.data.code != 0) {
              this.$message({
                type: "error",
                message: r.data.msg,
              });
            } else {
              this.$message({
                type: "success",
                message: r.data.msg,
              });
            }
          });
          this.signObj = row;
          this.cancel = true;
        } else {
          this.$message({
            type: "error",
            message: r.data.msg,
          });
        }
      }
    },
    analyzeIDCard(IDCard) {
      //获取用户身份证号码
      var userCard = IDCard;

      //如果身份证号码为undefind则返回空
      if (!userCard) {
        return false;
      }
      //获取出生年月日
      var yearBirth = userCard.substring(6, 10);
      var monthBirth = userCard.substring(10, 12);
      var dayBirth = userCard.substring(12, 14);
      console.log(yearBirth, monthBirth, dayBirth);

      //获取当前年月日并计算年龄
      var myDate = new Date();
      var monthNow = myDate.getMonth() + 1;
      var dayNow = myDate.getDate();
      var age = myDate.getFullYear() - yearBirth;
      if (
        monthNow < monthBirth ||
        (monthNow == monthBirth && dayNow < dayBirth)
      ) {
        age--;
      }
      if (age >= 18) {
        // this.$message({
        //   type:'success',
        //   message:'18'
        // })
        return true;
      }
      //  this.$message({
      //     type:'error',
      //     message:'15'
      //   })
      return false;
    },

    getStates() {
      return this.$http.get(this.mixinViewModuleOptions.getDataListURL, {
        params: {
          order: this.order,
          orderField: this.orderField,
          page: this.mixinViewModuleOptions.getDataListIsPage
            ? this.page
            : null,
          limit: this.mixinViewModuleOptions.getDataListIsPage
            ? this.limit
            : null,
          ...this.dataForm,
        },
      });
    },
    // 签约成功跳转页面到签约成功
    async signedOK(row) {
      this.applyId = row.id;
      this.signObj = row;
      this.getFactor();

      let res = await this.getStates();
      let { data } = res;

      if (data.code == 0) {
        let arr = data.data.list.filter((item) => item.id == this.signObj.id);
        console.log(arr[0]);

        if (arr[0].applyStatus == "4") {
          this.signed = false;
          this.addOrUpdateCloanVisible = true;
          this.$nextTick(() => {
            // this.$refs.addOrUpdatecloan.dialogVisibleok = true

            this.$refs.addOrUpdatecloan.getLoanData(this.signObj.id);
          });
        } else {
          this.$message({
            type: "warning",
            message: "签约未完成",
          });
        }
      }
    },
  },
  components: {
    AddOrUpdate,
    AddOrUpdateloan,
    AddOrUpdatee,

    perfect,
  },
};
</script>
  
  <style lang="scss" scoped>
.box-card {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  transform: translate(66px, 140px);

  width: 600px !important;
  height: 380px;
  text-align: center;
  // z-index: 999999999999;
  h3 {
    margin: 30px;
  }
  .card-btn {
    width: 60%;
    margin: 60px auto;
  }
  .footer-btn {
    height: 50px;
    width: 100%;
    display: flex;
    margin: 80px 0;

    justify-content: space-around;
  }
  p:nth-child(2) {
    margin: 130px 0;
    span {
      color: blue;
    }
  }
  ul {
    width: 100%;
    margin: 30px 0;
    padding-left: 168px;

    li {
      width: 100%;
      text-align: left;
      margin: 5px 0;
      span:nth-child(1) {
        width: 100px !important;
      }
      span {
        font-size: 12px;
        display: inline-block;
        text-align: left;
      }
    }
  }
}
.card-btn {
  display: flex;
  width: 82%;
  margin: 0 auto;
  justify-content: space-between;
  button {
    border: none;
    background: #3b46c4;
    width: 90px;
    height: 40px;
    border-radius: 4px;
    font-weight: 900;
    color: #fff;
  }
}

.mo {
  width: 200px;
  margin: 20px auto;
  height: 35px;
  line-height: 35px;
  background: #e9eafa;
  border-radius: 4px;
  color: #3d4090;
  > span {
    background: #e9eafa;
  }
}
.box-card1 {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  transform: translateX(100px);
  width: 920px;
  height: 380px;
  text-align: center;
  // z-index: 999999999999;
  .p2 {
    margin: 20px 0;
  }
  .footer-btn {
    height: 50px;
    width: 100%;
    display: flex;
    margin: 60px 0;
    justify-content: space-around;
  }
}

.input-box {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-top: 80px;
  position: relative;
  padding: 0px 15px;
  box-sizing: border-box;
  .input-code {
    width: 100%;
    height: 50px;
    position: absolute;
    left: 0px;
    top: 0px;
    box-sizing: border-box;
    color: transparent;
    background-color: transparent;
    opacity: 0;
  }
  .code-item {
    width: 40px;
    height: 50px;
    text-align: center;
    line-height: 50px;
    border-bottom: 1px solid#D8D8D8;
    margin-right: 10px;
    color: #444;
    font-size: 34px;
  }
  .code-item-active {
    border-bottom: 1px solid#F23026;
  }
}
.blue {
  color: blue;
  cursor: pointer;
}
.ipt_pwd {
  width: 245px;
  height: 37px;
  position: relative;
  // border: 1px solid #333;
  margin-right: 20px;
}
.passWord-box {
  border: 2px solid #ccc;
  border-radius: 15px;
  width: 300px;
  margin: 0px auto;
}

.get-password-box {
  display: flex;
  width: 346px;

  margin: 100px auto !important;
  justify-content: space-between;
}
.box-contract {
  display: flex;
  justify-content: center;
  align-items: center;
  .el-icon-star-on {
    font-size: 18px;
    color: #17b3a3;
    margin: 0 10px;
  }
}
.agreement {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
a {
  color: blue;
}

.box-yzm {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  transform: translate(92px, 75px);
  width: 500px;
  height: 380px;
  p {
    text-align: center;
  }
  .p2 {
    margin: 20px 0;
  }
  .footer-btn {
    height: 50px;
    width: 100%;
    display: flex;
    margin: 60px 0;
    justify-content: space-around;
  }
}

.input-box {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-top: 80px;
  position: relative;
  padding: 0px 15px;
  box-sizing: border-box;
  .input-code {
    width: 100%;
    height: 50px;
    position: absolute;
    left: 0px;
    top: 0px;
    box-sizing: border-box;
    color: transparent;
    background-color: transparent;
    opacity: 0;
  }
  .code-item {
    width: 40px;
    height: 50px;
    text-align: center;
    line-height: 50px;
    border-bottom: 1px solid#D8D8D8;
    margin-right: 10px;
    color: #444;
    font-size: 34px;
  }
  .code-item-active {
    border-bottom: 1px solid#F23026;
  }
}
.mobile-box {
  display: inline-block;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  > span {
    display: inline-block;
    width: 100px;
  }
}
.yellow {
  color: #facd56 !important;
}
</style>
  